import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const AlertInformationIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="alertInformation" ref={ref} {...props}>
    <path d="M12,21.75A9.75,9.75,0,1,1,21.75,12,9.76,9.76,0,0,1,12,21.75Zm0-18A8.25,8.25,0,1,0,20.25,12,8.26,8.26,0,0,0,12,3.75ZM12.75,17V12a.75.75,0,0,0-1.5,0v5a.75.75,0,0,0,1.5,0ZM12,6.75A1.25,1.25,0,1,0,13.25,8,1.25,1.25,0,0,0,12,6.75Z" />
  </Icon>
)) as IconWithRender;

AlertInformationIcon.displayName = 'AlertInformationIcon';
AlertInformationIcon.renderIcon = (props) => (
  <AlertInformationIcon {...props} />
);
export default AlertInformationIcon;
